import styled from 'styled-components';
import { forDesktop, forTablet, forMidDesktop } from '@westwing/ui-kit/breakPoints';
import Text from '@ids/components/Typography/Text';
import AspectRatio from '@ids/components/Layout/AspectRatio';

const PATH_BACKGROUND_COLOR = '#f6f0eb';

export const TOP_INSET = '5vw';

export const Steps = styled.div`
    position: relative;
    margin-bottom: 40px;

    &:before {
        content: '';
        position: absolute;
        background-color: ${PATH_BACKGROUND_COLOR};
        top: -${TOP_INSET};
        right: 10vw;
        left: 0;
        bottom: 0;
        z-index: -1;
    }

    ${forTablet`
        margin-bottom: 0;
        &:before {
            content: none;
        }
    `}
`;

export const Step = styled.div`
    display: flex;
    flex-direction: column;

    ${forTablet`
        display: grid;
        grid-template-rows: 25% calc(50% - 40px) 25% 40px;

        &[data-position='even'] {
            grid-template-columns: 60% 40%;
        }

        &[data-position='odd'] {
            grid-template-columns: 40% 60%;
        }
    `}

    &[data-last-step='true'] {
        margin-bottom: 0;
    }
`;

export const PathContainer = styled.div`
    ${forTablet`
        display: grid;
        grid-template-rows: 15% calc(70% - 40px) calc(15% + 40px);

        ${Step}[data-position="even"] & {
            grid-area: 1 / 1 / 5 / 2;
            
            grid-template-areas:
                '. . .'
                '. textPath textPath'
                '. noTextPath .';
            grid-template-columns: 5% 35% auto;
        }

        ${Step}[data-position="odd"] & {
            grid-area: 1 / 2 / 5 / 3;

            grid-template-areas:
                '. . .'
                'textPath textPath .'
                '. noTextPath .';
            grid-template-columns: auto 35% 5%;
        }
    `}

    ${forMidDesktop`
        ${Step}[data-position="even"] & {
            grid-template-columns: 5% 30% auto;
        }

        ${Step}[data-position="odd"] & {
            grid-template-columns: auto 30% 5%;
        }

        grid-template-rows: 20% calc(60% - 40px) calc(20% + 40px);
    `}
`;

export const TextPath = styled.div`
    padding: 5vw 15vw 5vw 5vw;

    ${Text} {
        margin-bottom: 10px;
        max-width: 550px;
    }

    ${forTablet`
        grid-area: textPath;
        background: ${PATH_BACKGROUND_COLOR};
        padding: 10px;
        
        ${Step}[data-position='odd'] & {
            ${Text} {
                text-align: right;
                margin-left: auto;
            }
        }
    `}

    ${forDesktop`
        padding: 2.5vw 3.25vw;
    `}
`;

export const NoTextPath = styled.div`
    ${forTablet`
        grid-area: noTextPath;

        ${Step}:not([data-last-step='true']) & {
            background: ${PATH_BACKGROUND_COLOR};
        }
    `}
`;

export const MediaWrapper = styled(AspectRatio)`
    position: relative;
    width: 90vw;
    margin: 0 auto;
    border: 1px solid ${({ theme }) => theme.colors.charcoal20};

    ${Step}[data-position="even"] & {
        grid-area: 1 / 2 / 4/ 2;
    }

    ${Step}[data-position="odd"] & {
        grid-area: 1 / 1 / 4 / 2;
    }

    ${forTablet`
        width: 100%;
    `}
`;
